/**
 * Clear WebSocket stream preferences from localStorage
 * Called on logout to reset stream detection for next login
 */
export const clearStreamPrefs = () => {
    try {
        localStorage.removeItem('ws_support_' + window.location.hostname + '_' + (window.location.port || '80'));
        // NB: the decoder hw/sw preference (dvlite_dec_${codec}_${w}x${h}) is intentionally NOT
        // cleared here. It's a per-device hardware characteristic (does this GPU pump this decode
        // workload?), shared with the playback player and stable across sessions — wiping it every
        // logout would just re-introduce the ~15s of pumping while it re-learns. Matches
        // PlaybackPlayer, which never clears it.
    } catch (e) { /* ignore */ }
};
